import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const NotificationPanel = ({ notifications }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleSendNotification = (notificationId) => {
    console.log('Sending notification:', notificationId);
    // Mock notification sending
  };

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    
    if (minutes < 60) {
      return `${minutes}m ago`;
    } else {
      return `${hours}h ago`;
    }
  };

  const getNotificationIcon = (type) => {
    return type === 'ending-soon' ? 'Clock' : 'AlertCircle';
  };

  const getNotificationColor = (type, status) => {
    if (status === 'sent') return 'text-gray-500';
    return type === 'ending-soon' ? 'text-yellow-600' : 'text-red-600';
  };

  return (
    <div className={`bg-white shadow-sm border-l border-gray-200 transition-all duration-300 ${
      isCollapsed ? 'w-12' : 'w-80'
    }`}>
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          {!isCollapsed && (
            <h3 className="text-lg font-medium text-gray-900">Notifications</h3>
          )}
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="p-1 text-gray-400 hover:text-gray-500"
          >
            <Icon name={isCollapsed ? "ChevronLeft" : "ChevronRight"} size={20} />
          </button>
        </div>
      </div>

      {!isCollapsed && (
        <div className="p-4">
          <div className="space-y-4">
            {notifications.map((notification) => (
              <div
                key={notification.id}
                className="bg-gray-50 rounded-lg p-3 border border-gray-200"
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center">
                    <Icon
                      name={getNotificationIcon(notification.type)}
                      size={16}
                      className={`mr-2 ${getNotificationColor(notification.type, notification.status)}`}
                    />
                    <span className="text-sm font-medium text-gray-900">
                      {notification.clientName}
                    </span>
                  </div>
                  <span className="text-xs text-gray-500">
                    {formatTimestamp(notification.timestamp)}
                  </span>
                </div>
                
                <p className="text-sm text-gray-600 mb-3">
                  {notification.message}
                </p>

                <div className="flex items-center justify-between">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    notification.status === 'sent' ?'bg-green-100 text-green-800' :'bg-yellow-100 text-yellow-800'
                  }`}>
                    <Icon
                      name={notification.status === 'sent' ? 'Check' : 'Clock'}
                      size={12}
                      className="mr-1"
                    />
                    {notification.status === 'sent' ? 'Sent' : 'Pending'}
                  </span>

                  {notification.status === 'pending' && (
                    <button
                      onClick={() => handleSendNotification(notification.id)}
                      className="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-green-600 rounded hover:bg-green-700"
                    >
                      <Icon name="Send" size={12} className="mr-1" />
                      Send Now
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          {notifications.length === 0 && (
            <div className="text-center py-8">
              <Icon name="Bell" size={48} className="mx-auto text-gray-400 mb-4" />
              <h4 className="text-sm font-medium text-gray-900 mb-2">
                No notifications
              </h4>
              <p className="text-sm text-gray-500">
                All notifications have been sent
              </p>
            </div>
          )}

          <div className="mt-6 pt-4 border-t border-gray-200">
            <button className="w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50">
              <Icon name="Settings" size={16} className="mr-2" />
              Notification Settings
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationPanel;